/* eslint-disable no-new-func */
import { stripTags } from '.';

export function updateGlobalPreLoading(loading: boolean): void {
  document
    .querySelector('#pre-loading')
    ?.setAttribute(
      'style',
      `display: ${loading ? 'block' : 'none'} !important`,
    );
}

export function getObjectValueByStringPath<R = any>(
  obj: Record<string, any>,
  path: string,
): any {
  if (!obj || !path) {
    return obj;
  }
  const formattedPath = stripTags(path)
    .split('-')
    .map(param => (!Number.isNaN(parseInt(param, 10)) ? `[${param}]` : param))
    .join('.')
    .replace(/(\.\[)/g, '[');

  const value = new Function('_', `return _.${formattedPath}`)(obj);

  return value as R;
}
